/**
 * Main App Component - FBCA Architecture
 * Feature-Based Component Architecture with auto-discovery routing
 */

import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './features/auth';
import { UserProvider } from './features/user';
import { PageRouter } from './lib/page-router';
import { ConsultProvider } from './features/main/components/landing/elfConsult';

function App() {
  return (
    <Router basename="/">
      <AuthProvider>
        <UserProvider>
          {/* Above the router so a page component can open the dialog from its
              own body — ElfShell mounts the dialog itself, but a page calling
              useConsult() sits above the shell it renders. */}
          <ConsultProvider>
            <PageRouter />
          </ConsultProvider>
        </UserProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;